export default __webpack_public_path__ + "static/media/working.b4050fbe.png";